<ng-container *ngIf="viewModel$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title">{{ vm.provider }} Payment Gateway</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <form [formGroup]="formGroup">
          <ng-container *ngIf="vm.paymentMethod === 'cc'">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="n">Name</label>
                <input id="n" type="text" class="form-control focus" formControlName="n" autocomplete="off"
                  aria-autocomplete="list" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="cn" class="col-3 col-form-label">Number</label>
                <input id="cn" type="text" class="form-control" formControlName="cn" autocomplete="off"
                  aria-autocomplete="list" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="em">MM</label>
                <ng-select labelForId="em" formControlName="em" placeholder="MM" [multiple]="false" [selectOnTab]="true"
                  [closeOnSelect]="true">
                  <ng-option [value]="1">1 - Jan</ng-option>
                  <ng-option [value]="2">2 - Feb</ng-option>
                  <ng-option [value]="3">3 - Mar</ng-option>
                  <ng-option [value]="4">4 - Apr</ng-option>
                  <ng-option [value]="5">5 - May</ng-option>
                  <ng-option [value]="6">6 - Jun</ng-option>
                  <ng-option [value]="7">7 - Jul</ng-option>
                  <ng-option [value]="8">8 - Aug</ng-option>
                  <ng-option [value]="9">9 - Sep</ng-option>
                  <ng-option [value]="10">10 - Oct</ng-option>
                  <ng-option [value]="11">11 - Nov</ng-option>
                  <ng-option [value]="12">12 - Dec</ng-option>
                </ng-select>
              </div>
              <div class="form-group col-md-4">
                <label for="em">YYYY</label>
                <ng-select labelForId="ey" formControlName="ey" [loading]="vm.years === undefined"
                  [items]="vm.years || []" placeholder="YYYY" [multiple]="false" [selectOnTab]="true"
                  [closeOnSelect]="true">
                </ng-select>
              </div>
              <div *ngIf="formGroup.errors?.['validExpiryValidator'] && (formGroup.touched || formGroup.dirty)" class="
                  col-md-4
                  cross-validation-error-message
                  alert alert-danger
                ">
                Expired Card
              </div>
              <div class="form-group col-md-4" *ngIf="vm.captureCardType">
                <label for="ct">Type</label>
                <ng-select labelForId="ct" formControlName="ct" [loading]="vm.cardTypes === undefined"
                  [items]="vm.cardTypes || []" placeholder="Card Type" [multiple]="false" [selectOnTab]="true"
                  [closeOnSelect]="true">
                </ng-select>
              </div>
            </div>

            <div class="row" *ngIf="vm.captureCCV">
              <div class="form-group col-md-4">
                <label for="v">CCV</label>
                <input id="v" type="text" class="form-control" formControlName="v" autocomplete="off"
                  aria-autocomplete="list" />
                <small class="form-text text-muted">Up to 4 digits</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" (click)="process()"
                  [disabled]="formGroup.invalid || vm.submitting">
                  Process
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="vm.paymentMethod === 'blackbaud-update-token'">
            <iframe seamless style="border: 0; min-height: 700px;" class="w-100 h-100" [srcdoc]="vm.blackbaudSrcDoc">
            </iframe>
          </ng-container>
        </form>
      </div>
    </div>
  </div>
</ng-container>